var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1741_60016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#FCFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0009 -0.000610352C6.03629 -0.000610352 2.61066 2.30662 0.993164 5.65158H19.0086C17.3911 2.30662 13.9655 -0.000610352 10.0009 -0.000610352Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0009 20.0001C6.03629 20.0001 2.61066 17.6929 0.993164 14.3479H19.0086C17.3911 17.6929 13.9655 20.0001 10.0009 20.0001Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5278 6.95587H0.472227C0.165898 7.9156 0 8.93806 0 9.99935C0 11.0606 0.165898 12.0831 0.472227 13.0428H19.5277C19.8341 12.0831 20 11.0606 20 9.99935C20 8.93806 19.8341 7.9156 19.5278 6.95587Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1144 4.62088L11.9302 4.07428L10.0006 8.44346L8.07098 4.07428L6.88672 4.62088L9.28234 9.99975L6.88672 15.3786L8.07098 15.9252L10.0006 11.556L11.9302 15.9252L13.1144 15.3786L10.7188 9.99975L13.1144 4.62088Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.805 5.13601C10.3465 4.63535 10.0006 4.34753 10.0006 4.34753C10.0006 4.34753 9.65473 4.63531 9.19629 5.13601V14.8634C9.65473 15.3641 10.0006 15.6519 10.0006 15.6519C10.0006 15.6519 10.3465 15.3641 10.805 14.8634V5.13601Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82617 7.00189V12.9984C8.31062 13.8568 8.90355 14.5604 9.34793 15.0269V4.97345C8.90355 5.43989 8.31059 6.14353 7.82617 7.00189Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1741 7.00237C11.6896 6.14398 11.0967 5.44038 10.6523 4.97394V15.0274C11.0967 14.5609 11.6896 13.8573 12.1741 12.9989V7.00237Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1738 7.00073V12.9973C12.6643 12.1282 13.0434 11.1005 13.0434 9.99905C13.0434 8.89761 12.6643 7.86987 12.1738 7.00073Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82563 7.00073V12.9973C7.3352 12.1282 6.95605 11.1005 6.95605 9.99905C6.95605 8.89761 7.3352 7.86987 7.82563 7.00073Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1741_60016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKes);
export default __webpack_public_path__ + "static/media/KES.6761b2fbf95131826b42c6603b2f5334.svg";
export { ForwardRef as ReactComponent };